import React from 'react';
import { HandoffSnapshot } from '../../../handoff-hub.types';
import { HandoffChecklistV2 } from '../edit-handoff/handoff-checklist-v2/handoff-checklist-v2';
import { mapSnapshotMetricsToVoiceAirChecklist } from '../edit-handoff/voice-air-handoff/voice-air-handoff.helpers';

type Props = {
  snapshotData: HandoffSnapshot;
  locationId: string;
};

export const VoiceAirSnapshotView = ({ snapshotData, locationId }: Props) => {
  const mappedMetrics = mapSnapshotMetricsToVoiceAirChecklist(
    snapshotData.metrics,
    locationId
  );

  return (
    <HandoffChecklistV2
      metrics={mappedMetrics}
      notes={snapshotData.officeExperience || ''}
      readOnly
    />
  );
};
